import { useEffect, useRef } from 'react';

const useFadeInAnimation = (selector, threshold = 0.1, dependencies = []) => {
  // Usar ref para almacenar las dependencias serializadas
  const depsRef = useRef(JSON.stringify(dependencies));
  const depsChanged = JSON.stringify(dependencies) !== depsRef.current;
  
  if (depsChanged) {
    depsRef.current = JSON.stringify(dependencies);
  }

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('fade-in');
          }
        });
      },
      { threshold }
    );

    const elements = document.querySelectorAll(selector);
    elements.forEach(item => observer.observe(item));

    return () => {
      elements.forEach(item => observer.unobserve(item));
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selector, threshold, depsRef.current]);
};

export default useFadeInAnimation;